import React from 'react';
import { Link } from 'react-router-dom';
import { HardHatIcon, PackageIcon, TruckIcon, FactoryIcon, ArrowRightIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
export function Applications() {
  const {
    lang
  } = useTranslation();
  const applications = lang === 'en' ? [{
    icon: PackageIcon,
    title: 'Logistics & Delivery'
  }, {
    icon: HardHatIcon,
    title: 'Construction Materials'
  }, {
    icon: TruckIcon,
    title: 'Moving & Furniture'
  }, {
    icon: FactoryIcon,
    title: 'Industrial Warehouses'
  }] : [{
    icon: PackageIcon,
    title: 'Logistika i dostava'
  }, {
    icon: HardHatIcon,
    title: 'Građevinski materijal'
  }, {
    icon: TruckIcon,
    title: 'Selidbe i nameštaj'
  }, {
    icon: FactoryIcon,
    title: 'Industrijska skladišta'
  }];
  return <section className="py-20 bg-dark-bg" data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-130">
            <span className="text-brand-yellow" data-id="element-131">
              {lang === 'en' ? 'Where is it used?' : 'Gde se koristi?'}
            </span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-132">
          {applications.map(app => {
          const Icon = app.icon;
          return <Card key={app.title} hover className="flex flex-col items-center text-center p-8" data-id="element-133">
                <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center mb-6" data-id="element-134">
                  <Icon className="w-8 h-8 text-brand-yellow" data-id="element-135" />
                </div>
                <h3 className="text-xl font-bold text-white" data-id="element-136">{app.title}</h3>
              </Card>;
        })}
        </div>
        <div className="text-center" data-id="element-137">
          <Link to="/applications" data-id="element-138">
            <Button variant="secondary" size="lg" data-id="element-139">
              {lang === 'en' ? 'View all applications' : 'Pogledajte sve primene'}
              <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-140" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}